import CrmCenteredTitle from '../../../components/CrmCenteredTitle';
import CrmLayout from '../../../components/CrmLayout';
import { useParams } from 'react-router-dom';
import { useMutation, useQuery } from '@apollo/client';
import { QUERY_CLIENT } from '../../../graphql/user';
import { Form, Input, Button, Radio } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { UPDATE_CLIENT } from '../../../graphql/client';
import { UPDATE_PARENT } from '../../../graphql/parent';

export function ClientAnket() {

    const { id } = useParams();

    const query = useQuery(QUERY_CLIENT, {
        variables: {
            id: id,
        },
    });

    const type = query.data?.usersPermissionsUser?.data?.attributes?.client?.data ? 'child' : 'parent';

    const [updateMutation, {loading}] = useMutation(type === 'child' ? UPDATE_CLIENT : UPDATE_PARENT);

    const client =
        query.data?.usersPermissionsUser?.data?.attributes?.client?.data ||
        query.data?.usersPermissionsUser?.data?.attributes?.parent?.data;
    const title = `${client?.attributes?.firstName} ${client?.attributes?.lastName}`;

    const onFinish = async (data) => {
        await updateMutation({
            variables: {
                id: client?.id,
                data: {
                    anket: data,
                }
            }
        })
    }

    if (!client) {return null}

    return (
        <CrmLayout>

            <CrmCenteredTitle title={`${title} – Анкета`}/>

            <Form size={'large'} layout={'vertical'} onFinish={onFinish} initialValues={{...client?.attributes?.anket}} disabled={loading}>
                <Form.Item name={'experience'} label={'Опыт занятий'}>
                    <Input.TextArea placeholder={'...'}/>
                </Form.Item>
                <Form.Item name={'contraindications'} label={'Противопоказания'}>
                    <Input.TextArea placeholder={'...'}/>
                </Form.Item>
                <Form.Item name={'fullFamily'} label={'Состав семьи'}>
                    <Radio.Group buttonStyle={'solid'} optionType={'button'} options={[
                        {label: 'Полная', value: true},
                        {label: 'Не полная', value: false},
                    ]}/>
                </Form.Item>
                <Form.Item name={'gadgetTime'} label={'Время за гаджетами'}>
                    <Input placeholder={'2 часа в день'}/>
                </Form.Item>
                <Form.Item name={'mainGoal'} label={'Основная цель'}>
                    <Input.TextArea placeholder={'...'}/>
                </Form.Item>
                <Form.Item>
                    <Button loading={loading} type={'primary'} htmlType={'submit'} icon={<SaveOutlined/>}>Сохранить</Button>
                </Form.Item>
            </Form>

        </CrmLayout>
    );
}
